import {useState} from "react";
import PaginationControl from "../../component/Pagination/PaginationControl";
import ContentContainer from "../../component/ContentContainer";
import {ApiUrl} from "../../auth/authMethods";
import OrderList from "../Order/Components/OrderList";
import ButtonReport from "./Components/ButtonReport";

export default function LateOrders() {

    const baseUrl = `${ApiUrl}/pedidos`
    const [loadData, setLoadData] = useState(true)

    const [size, setSize] = useState(10)
    const [page, setPage] = useState(0)
    const [sort, setSort] = useState("")

    const [totalPages, setTotalPages] = useState(0)
    const [totalElements, setTotalElements] = useState(0)

    const [filter, setFilter] = useState({})

    return <ContentContainer width='xl'>
        <div className="">
            <h1>Lista de Lotes Atrasados</h1>
            
        </div>
        <div className='text-end button-show'>
                    <ButtonReport/>
                </div>
        <OrderList
            baseUrl={baseUrl + '/late-list'}
            loadData={loadData}
            setLoadData={setLoadData}
            page={page}
            setPage={setPage}
            size={size}
            setSize={setSize}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            totalElements={totalElements}
            setTotalElements={setTotalElements}
            sort={sort} setSort={setSort}
            filter={filter} setFilter={setFilter}
            islate={true}
        />
        <PaginationControl
            totalElements={totalElements}
            page={page}
            setPage={setPage}
            size={size}
            setSize={setSize}
            setLoadData={setLoadData}
        />
    </ContentContainer>
}